import react       from '../images/react.svg';
import reactnative  from '../images/react-native.svg';
import flutter      from '../images/flutter.svg';
import kotlin       from '../images/kotlin.png';
import node         from '../images/node-js.svg';
import redux        from '../images/redux.svg';
import mongo        from '../images/mongo.png';
import mysql        from '../images/mysql.svg';
import firebase     from '../images/firebase.svg';
import elastic      from '../images/elastic.png';
import solidity     from '../images/solidity.svg';
import pytorch      from '../images/pytorch.png';
import python       from '../images/python.png';

export const skills = [
  { name: "React",          icon: react       },
  { name: "React Native",   icon: reactnative },
  { name: "Flutter",        icon: flutter     },
  { name: "Android Dev",    icon: kotlin      },
  { name: "Node / Express", icon: node        },
  { name: "Redux",          icon: redux       },
  { name: "MongoDB",        icon: mongo       },
  { name: "MySQL",          icon: mysql       },
  { name: "Firebase",       icon: firebase    },
  { name: "Elastic Stack",  icon: elastic     },
  { name: "Solidity",       icon: solidity    },
  { name: "PyTorch",        icon: pytorch     },
  { name: "Python",         icon: python      },
];
